var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01074 21.9726L12.6425 21.95L27.1172 7.52817C27.6853 6.95674 27.9978 6.19786 27.9978 5.3906C27.9978 4.58334 27.6853 3.82446 27.1172 3.25303L24.7338 0.855444C23.5977 -0.287415 21.6156 -0.281369 20.4885 0.850909L6.01074 15.2757V21.9726ZM22.6089 2.99301L24.9968 5.38607L22.5969 7.77761L20.2135 5.38153L22.6089 2.99301ZM9.01629 16.5365L18.078 7.50701L20.4614 9.90459L11.4012 18.9311L9.01629 18.9386V16.5365Z",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00555 28H24.0444C25.702 28 27.0499 26.644 27.0499 24.9766V11.873L24.0444 14.8964V24.9766H7.75131C7.71224 24.9766 7.67167 24.9917 7.63259 24.9917C7.583 24.9917 7.53341 24.9781 7.48232 24.9766H3.00555V3.8125H13.2951L16.3006 0.789062H3.00555C1.34799 0.789062 0 2.14507 0 3.8125V24.9766C0 26.644 1.34799 28 3.00555 28Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/iconEdit.0986c2e78923862cb67397b0ccde7674.svg";
export { ForwardRef as ReactComponent };